/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { DataUtil, ScrollableDataListRV, Title, translation } from 'plugin/liferay-widgets-react-web';
import StateValueActions from '../actions/StateValueActions';
import StateValueListItem from './StateValueListItem';

const StateValueDetailsListRenderer = ({ item, state }) => {
  const list = item;
  const listItems = DataUtil.asArray(item);

  const getTranslation = (state) => {
    let title = translation.trans(state.className + '.' + state.propName);

    if (state.className === 'ManualBooleanState') {
      title = 'Ereigniszustand';
    }
    return title;
  };

  return (
    <React.Fragment>
      <Title title={state ? getTranslation(state) : 'Status'}/>
      <ScrollableDataListRV
        list={list}
        ListItem={StateValueListItem}
        size="medium"
        loadMoreRows={(query) => StateValueActions.moreItems(list.name, query)}
        rowHeight={({ index }) => {
          const currentItem = listItems && listItems[index];
          // state set by an app user
          const hasUserTimestamp = currentItem && currentItem.userTimestamp;
          return hasUserTimestamp ? 70: 50;
        }}
      />
    </React.Fragment>);
};

StateValueDetailsListRenderer.propTypes = {
  item: PropTypes.object.isRequired,
  state: PropTypes.object
};

export default StateValueDetailsListRenderer;



// WEBPACK FOOTER //
// ./js/components/StateValueDetailsListRenderer.jsx